export const coinArr = {
    ada: require('@/assets/coin/ada.png'),
    atom: require('@/assets/coin/atom.png'),
    bch: require('@/assets/coin/bch.png'),
    bsv: require('@/assets/coin/bsv.png'),
    btc: require('@/assets/coin/btc.png'),
    dash: require('@/assets/coin/dash.png'),
    doge: require('@/assets/coin/doge.png'),
    eos: require('@/assets/coin/eos.png'),
    etc: require('@/assets/coin/etc.png'),
    eth: require('@/assets/coin/eth.png'),
    fil: require('@/assets/coin/fil.png'),
    iota: require('@/assets/coin/iota.png'),
    link: require('@/assets/coin/link.png'),
    ltc: require('@/assets/coin/ltc.png'),
    sol: require('@/assets/coin/sol.png'),
    sushi: require('@/assets/coin/sushi.png'),
    trx: require('@/assets/coin/trx.png'),
    uni: require('@/assets/coin/uni.png'),
    usdc: require('@/assets/coin/usdc.png'),
    usdt: require('@/assets/coin/usdt.png'),
    wtc: require('@/assets/coin/wtc.png'),
    xmr: require('@/assets/coin/xmr.png'),
    xrp: require('@/assets/coin/xrp.png'),
    yfi: require('@/assets/coin/yfi.png'),
    ftx: require('@/assets/coin/ftx.png'),
    xxx: require('@/assets/coin/xxx.png'),
    axv: require('@/assets/coin/axv.png'),
    dax: require('@/assets/coin/dax.png'),
}
